import { render, staticRenderFns } from "./ChainBase.vue?vue&type=template&id=59d428d8&scoped=true"
import script from "./ChainBase.vue?vue&type=script&lang=js"
export * from "./ChainBase.vue?vue&type=script&lang=js"
import style0 from "./ChainBase.vue?vue&type=style&index=0&id=59d428d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d428d8",
  null
  
)

export default component.exports